<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" v-if="!this.isPartner">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" v-else-if="this.isPartner">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="viewRecord" />
    </div>
</template>

<script>

import ClientService from "@/services/ClientService";
import UtilService from "@/services/UtilService";

export default {
  name: 'CellRendererActions',
   data() {
    return {
      isPartner: false,
    };
    },
  methods: {
    editRecord () {
      this.$router.push(`/apps/client/edit/${this.params.data.Id}`).catch(() => {})
    },
    viewRecord () {
      this.$router.push(`/apps/client/view/${this.params.data.Id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure to delete '+this.params.data.CompanyName+'?',
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      ClientService.delete(this.params.data.Id)
        .then(() => {
          UtilService.notifySuccessAlert(this.$vs, 'The selected Client was successfully deleted.');
        ClientService.getPartnerIdFromClients(this.params.data.Id)
              .on("value", (items) => {
                  let partnerId = items.val()[this.params.data.Id].Partner
                  ClientService.decClientCount(partnerId).then(() => {
                      console.log('code count updated successfully')
                }) 
                  this.fetch_user_data(this.params.data.Id);
                })
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    if(this.userInfo.Role === 'Partner Admin' || this.userInfo.Role === 'Partner Staff'){
      this.isPartner = true
    }
  }
}
</script>
